import { Link } from "react-router-dom";
import { LegalLayout, Clause, Bi, BiList, ORG_NAME } from "./LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout
      title="Terms & Conditions"
      titleBn="শর্তাবলি ও নিয়মাবলি"
      intro={
        <Bi
          en={
            <>
              These Terms &amp; Conditions (&ldquo;Terms&rdquo;) govern your access to and use of the
              website, applications and services of {ORG_NAME} (&ldquo;we&rdquo;, &ldquo;us&rdquo;,
              &ldquo;our&rdquo;, the &ldquo;Platform&rdquo;). By creating an account, purchasing a
              course, or otherwise using the Platform, you agree to these Terms, our{" "}
              <Link to="/privacy-policy" className="text-primary underline underline-offset-2">Privacy Policy</Link>{" "}
              and our{" "}
              <Link to="/refund-policy" className="text-primary underline underline-offset-2">Refund Policy</Link>.
              If you do not agree, you must not use the Platform.
            </>
          }
          bn={
            <>
              এই শর্তাবলি ও নিয়মাবলি (&ldquo;শর্তাবলি&rdquo;) {ORG_NAME}-এর ওয়েবসাইট, অ্যাপ্লিকেশন ও সেবা
              ব্যবহারের ক্ষেত্রে প্রযোজ্য। অ্যাকাউন্ট তৈরি, কোর্স ক্রয় বা প্ল্যাটফর্ম ব্যবহারের মাধ্যমে আপনি এই
              শর্তাবলি, আমাদের{" "}
              <Link to="/privacy-policy" className="text-primary underline underline-offset-2">প্রাইভেসি নীতিমালা</Link>{" "}
              ও{" "}
              <Link to="/refund-policy" className="text-primary underline underline-offset-2">ফেরত নীতিমালায়</Link>{" "}
              সম্মতি প্রদান করছেন। সম্মত না হলে প্ল্যাটফর্ম ব্যবহার করবেন না।
            </>
          }
        />
      }
    >
      <Clause n="1" title="Eligibility & Accounts" titleBn="যোগ্যতা ও অ্যাকাউন্ট">
        <BiList
          items={[
            [
              "You must provide accurate, current and complete information when registering, and keep it up to date.",
              "নিবন্ধনের সময় সঠিক, হালনাগাদ ও সম্পূর্ণ তথ্য প্রদান করতে হবে এবং তা হালনাগাদ রাখতে হবে।",
            ],
            [
              "You are responsible for keeping your password and login credentials confidential and for all activity under your account.",
              "আপনার পাসওয়ার্ড ও লগইন তথ্য গোপন রাখা এবং অ্যাকাউন্টের অধীনে সকল কার্যক্রমের দায়িত্ব আপনার।",
            ],
            [
              "Each account is for a single individual student. If you are under 18, a parent or legal guardian must accept these Terms on your behalf.",
              "প্রতিটি অ্যাকাউন্ট একজন শিক্ষার্থীর জন্য। আপনার বয়স ১৮ বছরের কম হলে অভিভাবককে আপনার পক্ষে এই শর্তাবলি গ্রহণ করতে হবে।",
            ],
          ]}
        />
      </Clause>

      <Clause n="2" title="Purchases & Payment" titleBn="ক্রয় ও পেমেন্ট">
        <BiList
          items={[
            [
              "The price of every course and service is shown before checkout. Payments are accepted through bKash and other approved methods displayed on the Platform.",
              "প্রতিটি কোর্স ও সেবার মূল্য চেকআউটের আগে প্রদর্শিত হয়। পেমেন্ট বিকাশ ও প্ল্যাটফর্মে প্রদর্শিত অন্যান্য অনুমোদিত পদ্ধতিতে গ্রহণ করা হয়।",
            ],
            [
              "Before completing a purchase, you must confirm that you have read and accepted these Terms, the Privacy Policy and the Refund Policy.",
              "ক্রয় সম্পন্ন করার আগে আপনাকে নিশ্চিত করতে হবে যে আপনি এই শর্তাবলি, প্রাইভেসি নীতিমালা ও ফেরত নীতিমালা পড়েছেন ও গ্রহণ করেছেন।",
            ],
            [
              "Purchasing a course grants a limited, personal, non-transferable licence to access the content for the access period stated on the course page. It does not transfer ownership of any content.",
              "কোর্স ক্রয় কেবল কোর্স পৃষ্ঠায় উল্লিখিত সময়ের জন্য কনটেন্ট ব্যবহারের একটি সীমিত, ব্যক্তিগত ও অ-হস্তান্তরযোগ্য লাইসেন্স প্রদান করে; এটি কোনো কনটেন্টের মালিকানা হস্তান্তর করে না।",
            ],
            [
              "All refunds and cancellations are handled solely under our Refund Policy.",
              "সকল ফেরত ও বাতিলকরণ কেবল আমাদের ফেরত নীতিমালা অনুযায়ী পরিচালিত হয়।",
            ],
          ]}
        />
      </Clause>

      <Clause n="3" title="Intellectual Property Rights" titleBn="মেধাস্বত্ব অধিকার">
        <Bi
          en={
            <>
              All learning materials on the Platform &mdash; including course videos, live class
              recordings, PDFs, notes, mock tests, quizzes, audio files, images, question banks,
              software, branding and page design &mdash; are the exclusive intellectual property of
              {" "}{ORG_NAME} or its licensors, and are protected under the Copyright Act, 2023 and
              other applicable laws of Bangladesh.
            </>
          }
          bn={
            <>
              প্ল্যাটফর্মের সকল শিক্ষা-উপকরণ &mdash; কোর্স ভিডিও, লাইভ ক্লাস রেকর্ডিং, পিডিএফ, নোট, মক টেস্ট,
              কুইজ, অডিও ফাইল, ছবি, প্রশ্নব্যাংক, সফটওয়্যার, ব্র্যান্ডিং ও পৃষ্ঠা-ডিজাইনসহ &mdash; {ORG_NAME}
              অথবা এর লাইসেন্সদাতাদের একচ্ছত্র মেধাস্বত্ব এবং কপিরাইট আইন, ২০২৩ ও বাংলাদেশের অন্যান্য প্রযোজ্য
              আইন দ্বারা সুরক্ষিত।
            </>
          }
        />
        <Bi
          en={<>The following are strictly prohibited without our prior written permission:</>}
          bn={<>আমাদের পূর্ব লিখিত অনুমতি ছাড়া নিম্নোক্ত কাজগুলো কঠোরভাবে নিষিদ্ধ:</>}
        />
        <BiList
          items={[
            [
              "Copying, recording, screen-recording, downloading or reproducing any content.",
              "কোনো কনটেন্ট কপি, রেকর্ড, স্ক্রিন-রেকর্ড, ডাউনলোড বা পুনরুৎপাদন করা।",
            ],
            [
              "Sharing, redistributing, reselling, uploading or publishing content on any platform, group or website.",
              "কোনো প্ল্যাটফর্ম, গ্রুপ বা ওয়েবসাইটে কনটেন্ট শেয়ার, পুনর্বণ্টন, পুনর্বিক্রয়, আপলোড বা প্রকাশ করা।",
            ],
            [
              "Sharing your account, login details, or purchased content with any other person.",
              "আপনার অ্যাকাউন্ট, লগইন তথ্য বা ক্রয়কৃত কনটেন্ট অন্য কারও সাথে শেয়ার করা।",
            ],
            [
              "Any commercial use of our content, or use to create competing or derivative products.",
              "আমাদের কনটেন্টের যেকোনো বাণিজ্যিক ব্যবহার, বা প্রতিযোগী বা অনুরূপ পণ্য তৈরিতে ব্যবহার।",
            ],
            [
              "Removing or altering any copyright, watermark or ownership notice.",
              "কোনো কপিরাইট, ওয়াটারমার্ক বা মালিকানা নোটিশ অপসারণ বা পরিবর্তন করা।",
            ],
          ]}
        />
      </Clause>

      <Clause n="4" title="Consequences of Copyright Infringement & Piracy" titleBn="কপিরাইট লঙ্ঘন ও পাইরেসির পরিণতি">
        <Bi
          en={
            <>
              Any copyright infringement, piracy, account sharing or unauthorised distribution of our
              content is a serious violation. It may result in any or all of the following, at our
              sole discretion and without prior notice:
            </>
          }
          bn={
            <>
              আমাদের কনটেন্টের যেকোনো কপিরাইট লঙ্ঘন, পাইরেসি, অ্যাকাউন্ট শেয়ারিং বা অননুমোদিত বিতরণ একটি গুরুতর
              লঙ্ঘন। এর ফলে আমাদের এককভাবে নির্ধারিত সিদ্ধান্তে এবং পূর্ব নোটিশ ছাড়াই নিম্নোক্ত যেকোনো বা সকল
              ব্যবস্থা নেওয়া হতে পারে:
            </>
          }
        />
        <BiList
          items={[
            [
              "Immediate suspension or permanent termination of your account.",
              "আপনার অ্যাকাউন্ট তাৎক্ষণিক স্থগিত বা স্থায়ীভাবে বাতিল করা।",
            ],
            [
              "Cancellation of course access without any refund.",
              "কোনো ফেরত ছাড়াই কোর্স অ্যাক্সেস বাতিল করা।",
            ],
            [
              "Legal action, including claims for damages and criminal proceedings, under the Copyright Act, 2023 and other applicable laws of Bangladesh.",
              "কপিরাইট আইন, ২০২৩ ও বাংলাদেশের অন্যান্য প্রযোজ্য আইনের অধীনে ক্ষতিপূরণ দাবি ও ফৌজদারি কার্যক্রমসহ আইনগত ব্যবস্থা।",
            ],
          ]}
        />
      </Clause>

      <Clause n="5" title="Student Responsibilities & Acceptable Use" titleBn="শিক্ষার্থীর দায়িত্ব ও যথাযথ ব্যবহার">
        <Bi
          en={<>As a user of the Platform, you agree to:</>}
          bn={<>প্ল্যাটফর্মের ব্যবহারকারী হিসেবে আপনি সম্মত হচ্ছেন যে:</>}
        />
        <BiList
          items={[
            [
              "Use the Platform only for lawful, personal educational purposes.",
              "প্ল্যাটফর্ম কেবল বৈধ ও ব্যক্তিগত শিক্ষার উদ্দেশ্যে ব্যবহার করবেন।",
            ],
            [
              "Keep your account secure and never share your credentials.",
              "আপনার অ্যাকাউন্ট নিরাপদ রাখবেন এবং লগইন তথ্য কখনো শেয়ার করবেন না।",
            ],
            [
              "Provide accurate registration and payment information.",
              "সঠিক নিবন্ধন ও পেমেন্ট তথ্য প্রদান করবেন।",
            ],
            [
              "Communicate respectfully with teachers, staff and other students; harassment, abusive language or discrimination is not tolerated.",
              "শিক্ষক, কর্মী ও অন্যান্য শিক্ষার্থীর সাথে সম্মানজনকভাবে যোগাযোগ করবেন; হয়রানি, আপত্তিকর ভাষা বা বৈষম্য সহ্য করা হবে না।",
            ],
            [
              "Not attempt to bypass Platform security, disrupt the service, or access content you have not purchased.",
              "প্ল্যাটফর্মের নিরাপত্তা এড়ানো, সেবায় বিঘ্ন ঘটানো বা ক্রয় করেননি এমন কনটেন্ট অ্যাক্সেসের চেষ্টা করবেন না।",
            ],
            [
              "Not upload unlawful, harmful, misleading or infringing material to any community, chat or feedback feature.",
              "কোনো কমিউনিটি, চ্যাট বা মতামত ফিচারে বেআইনি, ক্ষতিকর, বিভ্রান্তিকর বা লঙ্ঘনকারী উপকরণ আপলোড করবেন না।",
            ],
          ]}
        />
      </Clause>

      <Clause n="6" title="Exam & Mock Test Integrity" titleBn="পরীক্ষা ও মক টেস্টের সততা">
        <Bi
          en={
            <>
              Cheating, impersonation, using unauthorised aids, sharing questions or answers, or any
              other form of misconduct during exams, mock tests or quizzes is strictly prohibited. We
              may invalidate results, withhold or revoke certificates, and suspend or terminate
              accounts for exam misconduct, without refund.
            </>
          }
          bn={
            <>
              পরীক্ষা, মক টেস্ট বা কুইজ চলাকালীন নকল, ছদ্মবেশ, অননুমোদিত সহায়তা ব্যবহার, প্রশ্ন বা উত্তর শেয়ার
              করা কিংবা অন্য যেকোনো অসদাচরণ কঠোরভাবে নিষিদ্ধ। পরীক্ষায় অসদাচরণের জন্য আমরা ফলাফল বাতিল,
              সার্টিফিকেট স্থগিত বা প্রত্যাহার এবং কোনো ফেরত ছাড়াই অ্যাকাউন্ট স্থগিত বা বাতিল করতে পারি।
            </>
          }
        />
      </Clause>

      <Clause n="7" title="Course Information & Changes" titleBn="কোর্সের তথ্য ও পরিবর্তন">
        <Bi
          en={
            <>
              Course syllabus, schedule, instructor and access period are shown on each course page.
              We may make minor changes to schedule or content; for significant changes we will
              inform enrolled students. Certificates, where offered, require meeting the stated
              attendance, assessment or completion criteria &mdash; purchase alone does not guarantee
              a certificate or any specific outcome such as passing an exam, admission, a visa or
              employment.
            </>
          }
          bn={
            <>
              কোর্সের সিলেবাস, সময়সূচি, প্রশিক্ষক ও অ্যাক্সেস সময় প্রতিটি কোর্স পৃষ্ঠায় দেখানো হয়। আমরা
              সময়সূচি বা কনটেন্টে ছোটখাটো পরিবর্তন করতে পারি; বড় পরিবর্তনের ক্ষেত্রে ভর্তি শিক্ষার্থীদের অবহিত
              করা হবে। প্রযোজ্য ক্ষেত্রে সার্টিফিকেটের জন্য উল্লিখিত উপস্থিতি, মূল্যায়ন বা সম্পন্নকরণের শর্ত পূরণ
              করতে হবে &mdash; কেবল কোর্স ক্রয় সার্টিফিকেট বা পরীক্ষায় উত্তীর্ণ, ভর্তি, ভিসা বা চাকরির মতো কোনো
              নির্দিষ্ট ফলাফল নিশ্চিত করে না।
            </>
          }
        />
      </Clause>

      <Clause n="8" title="Account Suspension & Termination" titleBn="অ্যাকাউন্ট স্থগিত ও বাতিলকরণ">
        <Bi
          en={
            <>
              We may suspend or terminate your account, temporarily or permanently, for breach of
              these Terms, payment fraud, account sharing, copyright violation, exam misconduct, or
              misuse of the Platform. Where termination results from your breach, no refund is due.
            </>
          }
          bn={
            <>
              এই শর্তাবলি লঙ্ঘন, পেমেন্ট জালিয়াতি, অ্যাকাউন্ট শেয়ারিং, কপিরাইট লঙ্ঘন, পরীক্ষায় অসদাচরণ বা
              প্ল্যাটফর্মের অপব্যবহারের কারণে আমরা আপনার অ্যাকাউন্ট সাময়িক বা স্থায়ীভাবে স্থগিত বা বাতিল করতে
              পারি। আপনার লঙ্ঘনের কারণে বাতিল হলে কোনো ফেরত প্রযোজ্য নয়।
            </>
          }
        />
      </Clause>

      <Clause n="9" title="Disclaimers & Limitation of Liability" titleBn="দায় অস্বীকৃতি ও দায়সীমা">
        <Bi
          en={
            <>
              The Platform and its content are provided on an &ldquo;as is&rdquo; and &ldquo;as
              available&rdquo; basis for educational purposes. To the maximum extent permitted by the
              applicable laws of Bangladesh, our total liability arising from your use of the Platform
              will not exceed the amount you paid for the specific product giving rise to the claim.
              Nothing in these Terms excludes any liability that cannot lawfully be excluded.
            </>
          }
          bn={
            <>
              প্ল্যাটফর্ম ও এর কনটেন্ট শিক্ষার উদ্দেশ্যে &ldquo;যেমন আছে&rdquo; ও &ldquo;যেমন উপলব্ধ&rdquo;
              ভিত্তিতে প্রদান করা হয়। বাংলাদেশের প্রযোজ্য আইন দ্বারা অনুমোদিত সর্বোচ্চ সীমা পর্যন্ত, প্ল্যাটফর্ম
              ব্যবহারের ফলে উদ্ভূত আমাদের সামগ্রিক দায় সংশ্লিষ্ট পণ্যের জন্য আপনার পরিশোধিত অর্থের বেশি হবে না।
              এই শর্তাবলির কোনো কিছুই আইনত অপরিহার্য কোনো দায় অব্যাহতি দেয় না।
            </>
          }
        />
      </Clause>

      <Clause n="10" title="Governing Law & Updates" titleBn="প্রযোজ্য আইন ও হালনাগাদ">
        <Bi
          en={
            <>
              These Terms are governed by and construed in accordance with the laws of Bangladesh,
              and any dispute is subject to the exclusive jurisdiction of the courts of Bangladesh. We
              may update these Terms from time to time; continued use of the Platform after an update
              constitutes acceptance of the revised Terms.
            </>
          }
          bn={
            <>
              এই শর্তাবলি বাংলাদেশের আইন অনুযায়ী পরিচালিত ও ব্যাখ্যাত হবে এবং যেকোনো বিরোধ বাংলাদেশের আদালতের
              একচ্ছত্র এখতিয়ারভুক্ত। আমরা সময়ে সময়ে এই শর্তাবলি হালনাগাদ করতে পারি; হালনাগাদের পর প্ল্যাটফর্ম
              ব্যবহার অব্যাহত রাখা সংশোধিত শর্তাবলি গ্রহণ হিসেবে গণ্য হবে।
            </>
          }
        />
      </Clause>
    </LegalLayout>
  );
}
